import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import fr from './translations/fr.json';
import lt from './translations/lt.json';
import it from './translations/it.json';
import lv from './translations/lv.json';
import el from './translations/el.json';
import nl from './translations/nl.json';
import es from './translations/es.json';
import et from './translations/et-EE.json';
import pt from './translations/pt.json';
import de from './translations/de.json';
import ru from './translations/ru.json';

i18n.use(initReactI18next).init({
  resources: {
    en,
    el,
    es,
    et,
    fr,
    it,
    lt,
    lv,
    nl,
    pt,
    de,
    ru,
  },
  lng: 'en', // if you're using a language detector, do not define the lng option
  fallbackLng: 'en',

  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});

export default i18n;
